var _path, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicrophoneOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7344 10.6406C19.7344 10.5375 19.65 10.4531 19.5469 10.4531H18.1406C18.0375 10.4531 17.9531 10.5375 17.9531 10.6406C17.9531 13.9289 15.2883 16.5938 12 16.5938C8.71172 16.5938 6.04688 13.9289 6.04688 10.6406C6.04688 10.5375 5.9625 10.4531 5.85938 10.4531H4.45312C4.35 10.4531 4.26562 10.5375 4.26562 10.6406C4.26562 14.5945 7.23281 17.857 11.0625 18.3187V20.7188H7.65703C7.33594 20.7188 7.07812 21.0539 7.07812 21.4688V22.3125C7.07812 22.4156 7.14375 22.5 7.22344 22.5H16.7766C16.8562 22.5 16.9219 22.4156 16.9219 22.3125V21.4688C16.9219 21.0539 16.6641 20.7188 16.343 20.7188H12.8438V18.3305C16.718 17.9086 19.7344 14.6273 19.7344 10.6406ZM12 14.625C14.2008 14.625 15.9844 12.8625 15.9844 10.6875V5.4375C15.9844 3.2625 14.2008 1.5 12 1.5C9.79922 1.5 8.01562 3.2625 8.01562 5.4375V10.6875C8.01562 12.8625 9.79922 14.625 12 14.625ZM9.79688 5.4375C9.79688 4.25156 10.7789 3.28125 12 3.28125C13.2211 3.28125 14.2031 4.25156 14.2031 5.4375V10.6875C14.2031 11.8734 13.2211 12.8438 12 12.8438C10.7789 12.8438 9.79688 11.8734 9.79688 10.6875V5.4375Z",
    fill: "white"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 2.70711,
    y1: 2.29289,
    x2: 22.5061,
    y2: 22.0919,
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrophoneOff);
export default __webpack_public_path__ + "static/media/microphone-off.681f2f053a71127969a82bbc0bbdfd74.svg";
export { ForwardRef as ReactComponent };